import { render, staticRenderFns } from "./LongTextType.vue?vue&type=template&id=28c186ad&"
import script from "./LongTextType.vue?vue&type=script&lang=js&"
export * from "./LongTextType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports